// extracted by mini-css-extract-plugin
export var deliveryContent = "styles-module--deliveryContent--3a7c8";
export var deliveryInfo = "styles-module--deliveryInfo--89247";
export var deliveryProvider = "styles-module--deliveryProvider--a0fad";
export var deliveryWrapper = "styles-module--deliveryWrapper--53933";
export var loaderWrapper = "styles-module--loaderWrapper--9b501";
export var wrapper = "styles-module--wrapper--76a85";